import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-download",
  "use": "icon-download-usage",
  "viewBox": "0 0 10 11.99",
  "content": "<symbol viewBox=\"0 0 10 11.99\" id=\"icon-download\">\r\n    <path d=\"M9.13,10.5H.83a.79.79,0,0,0-.7.6.66.66,0,0,0,.36.8A.79.79,0,0,0,1,12H9.34a.76.76,0,0,0,.54-.8A.78.78,0,0,0,9.13,10.5Z\" transform=\"translate(0 -0.01)\" />\r\n    <path d=\"M.4,5.3,4.46,9.5h0a.74.74,0,0,0,1.05,0c.06-.1.11-.1.17-.2L8.95,6c.29-.3.59-.6.87-.9a.71.71,0,0,0-.05-1L9.64,4a.68.68,0,0,0-.94.21C7.78,5.1,6.85,6,5.93,7a.33.33,0,0,0-.15.2s0,0,0-.1V2.3c0-.5,0-1,0-1.5A.72.72,0,0,0,4.66.1a.69.69,0,0,0-.38.7V7.2A.77.77,0,0,1,4.12,7c-.83-.8-1.66-1.6-2.5-2.5-.14-.1-.28-.3-.43-.4L1.12,4A.66.66,0,0,0,.2,4.1a.73.73,0,0,0,0,1A.38.38,0,0,0,.4,5.3Z\" transform=\"translate(0 -0.01)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/general/svg/download.svg
// module id = 5mra
// module chunks = 0